import _ from 'underscore'

export default function friends(state = {}, {type,data}) {
  if(type !== 'friendList update') return state
  data = data || []
  let friends = {}
  data.forEach(user=>{
    let uid = 'facebook:'+user.id
    friends[uid] = {...user,uid}
  })
  return _.isEqual(state,friends) ? state : friends
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/friends.js
 **/